var render, staticRenderFns
import script from "./RichTextDisplay.vue?vue&type=script&lang=js"
export * from "./RichTextDisplay.vue?vue&type=script&lang=js"
import style0 from "./RichTextDisplay.vue?vue&type=style&index=0&id=6db31173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db31173",
  null
  
)

export default component.exports